import { useTranslations } from "next-intl";
import Link from "next/link";
import { useAppSelector } from "@/redux/store";

const accountLinks = [
  {
    id: 1,
    labelKey: "loginRegister",
    href: "/signin",
  },
  {
    id: 2,
    labelKey: "cart",
    href: "/cart",
  },
  {
    id: 3,
    labelKey: "shop",
    href: "/",
  },
];

export default function AccountLinks() {
  const t = useTranslations();
  const tLinks = useTranslations("AccountLinks");
  const isAuthenticated = useAppSelector(
    (state) => state.authReducer.isAuthenticated
  );

  const resolvedAccountLinks = accountLinks.map((link) => {
    if (link.id === 1 && isAuthenticated) {
      return {
        ...link,
        href: "/my-account",
      };
    }

    return link;
  });

  return (
    <div className="w-full sm:w-auto">
      <h2 className="mb-7.5 text-custom-1 font-medium text-dark">
        {t("Account.title")}
      </h2>

      <ul className="flex flex-col gap-3.5">
        {resolvedAccountLinks.map((link) => (
          <li key={link.id}>
            <Link
              className="ease-out duration-200 hover:text-blue"
              href={link.href}
            >
              {link.id === 1 && isAuthenticated
                ? t("MyAccount.title")
                : tLinks(link.labelKey)}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
